import {defineMessages, useIntl} from 'react-intl';

import {view} from '@sail/ui';

const messages = defineMessages({
  disclaimer: {
    id: 'conversations_assistant.footer.disclaimer',
    description: 'Disclaimer text footer for the ai assistant',
    defaultMessage: 'AI may make mistakes. Verify important information.',
  },
});

export const StripeAssistantDisclaimer = () => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        color: 'form.placeholder',
        font: 'label.small',
        flexGrow: 0,
        width: 'fill',
        paddingX: 'space.200',
      }}
    >
      <view.div
        css={{
          textAlign: 'center',
          width: 'fill',
        }}
      >
        {intl.formatMessage(messages.disclaimer)}
      </view.div>
    </view.div>
  );
};
